import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

export interface SilobagProtocolPayload {
  query?: {
    ids: string[];
  };
}
export interface SilobagProtocol {
  id: number;
  silobag_id: string;
  silobag_protocol_types_id: number;
  silobag_protocol_clients_id: number | null;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface MonitoredSilobagProtocol {
  silobag_id: string;
  is_monitored: boolean;
  protocol: SilobagProtocol | null;
}

// ✅ implementado
export async function listMonitoredSilobagProtocols({ query: rawQuery }: SilobagProtocolPayload) {
  const query = transformIntoQueryParamString(rawQuery || {});

  const { response, data } = await BACKEND.get<MonitoredSilobagProtocol[]>(ENDPOINT.SILOBAGS_MONITORING, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
